import bricks from '../assets/MaterialsIcon/brick.png';
import cement from '../assets/MaterialsIcon/cement.png';
import concrete from '../assets/MaterialsIcon/concrete-block.png';
import paints from '../assets/MaterialsIcon/paint.png';
import inventory from '../assets/MaterialsIcon/inventory.png';

export const materialIcons = {
    bricks,
    cement,
    concrete,
    paints,
    inventory,
};

export default materialIcons;